/** What a failed mailing request means, in words, and which language it is about. */
import { ApiError } from '@/api/client';
import { apiErrorText } from '@/api/opengater/errors';
import { plural } from '@/lib/plural';
import { STATUS_LABEL } from './mailingText';
import { serverProblemText } from './telegramHtml';
/** The `{code, …}` the users service puts in `detail`, or a bare code there. */
function detailOf(e) {
    if (!(e instanceof ApiError))
        return null;
    const body = e.body;
    const d = body && typeof body === 'object' && 'detail' in body ? body.detail : body;
    if (typeof d === 'string')
        return { code: d };
    if (d && typeof d === 'object' && !Array.isArray(d) && typeof d.code === 'string') {
        return d;
    }
    return null;
}
function textOf(d) {
    switch (d.code) {
        case 'mailing_status_conflict':
            return d.status
                ? `Уже нельзя: рассылка сейчас «${STATUS_LABEL[d.status] ?? d.status}»`
                : 'Действие не подходит к статусу рассылки';
        case 'author_profile_not_found':
            return 'У твоего аккаунта нет профиля в сервисе пользователей — тест отправить некуда';
        case 'invalid_html': {
            const tags = (d.tags ?? []).map((t) => `<${t}>`).join(', ');
            const parts = [
                tags && `теги ${tags} не поддерживаются или не закрыты`,
                ...(d.problems ?? []).map(serverProblemText),
            ].filter(Boolean);
            return parts.length ? `Разметка: ${parts.join('; ')}` : 'Разметка не подходит для Telegram';
        }
        case 'text_too_long':
            return d.excess != null
                ? `Длиннее на ${d.excess} ${plural(d.excess, 'знак', 'знака', 'знаков')}${d.limit ? ` (можно ${d.limit})` : ''}`
                : 'Текст слишком длинный';
        case 'email_subject_required':
            return 'Нужна тема письма';
        case 'gift_button_text_required':
            return 'Нужен текст кнопки подарка';
        case 'gift_expired':
            return 'Подарок истёк — выбери другой или продли срок в «Подарках»';
        case 'scheduled_at_not_in_future':
            return 'Время запуска уже прошло';
        case 'no_recipients':
            return 'Никому не уйдёт — проверь аудиторию и переводы';
        case 'translation_not_found':
            return 'Нет перевода на этот язык';
        case 'no_test_contact':
            return 'У тебя нет контакта ни в одном из выбранных каналов';
        case 'media_type_unsupported':
            return 'Такой файл не подойдёт: нужен JPG, PNG, GIF или MP4';
        case 'media_too_large':
            return d.limit_bytes
                ? `Файл больше ${Math.round(d.limit_bytes / 1024 / 1024)} МБ`
                : 'Файл слишком большой';
        case 'storage_rejected_upload':
            return 'Хранилище не приняло файл';
        case 'storage_unavailable':
            return 'Хранилище недоступно — попробуй позже';
        case 'mailing_not_found':
            return 'Рассылки нет — возможно, её удалили';
        case 'gift_not_found':
            return 'Подарка нет — возможно, его удалили';
        default:
            return null;
    }
}
export function mailingProblem(e, fallback) {
    const d = detailOf(e);
    const text = d && textOf(d);
    if (d && text)
        return d.language ? { text, language: d.language } : { text };
    return { text: apiErrorText(e, fallback) };
}
